import { FindMappingByTypeResponseDtoType } from "~/gen/api"
import { useFindTypeKeys } from "~/gen/api/hooks"

export const useFindTypeKeysQuery = (type: FindMappingByTypeResponseDtoType) =>
  useFindTypeKeys({ type })
